'use strict';

import * as Props from '../Props';

const angular = require('angular');

const AttachmentProperties = {
    Basic: {
        'ControlType': 'Attachment',
        'Label': {
            name: 'label',
            selectedValue: 'Attachment',
            type: 'textbox',
            onClickFunction: 'openLanguageDialog',
            addOnButton: 'fa fa-globe'
        },
        'Field Name': Props.getFieldName('Attachment'),
        'Data Field Name': Props.getDataFieldName('Attachment'),
        'Value': {
            selectedValue: [],
            type: 'textbox',
            hidden: true
        },
        'Required': {
            name: 'required',
            selectedValue: false,
            type: 'checkbox'
        },
        'Name': {
            selectedValue: 'Basic',
            hidden: true
        }
    },
    Display: {
        'Read-only': {
            name: 'read.only',
            selectedValue: false,
            type: 'checkbox'
        },
        'Hidden': {
            name: 'hidden',
            selectedValue: false,
            type: 'checkbox'
        },
        'Generate Thumbnail':{
            name: 'generate-thumbnail',
            selectedValue: false,
            type: 'checkbox',
            onChangeFunction: 'onThumbnailViewChanged',
        },
        'Caption':{
            name: 'caption',
            selectedValue: false,
            type: 'checkbox'
        },
        'Caption Position': {
            name: 'caption.position',
            type: 'dd',
            options: [
                {
                    value: 'top',
                    key: 'Top'
                }, {
                    value: 'bottom',
                    key: 'Bottom'
                }],
            selectedValue: 'top',
        },
        'Thumbnail Size': {
            name: 'thumbnail.size',
            type: 'dd',
            options: [
                {
                    value: 'standard',
                    key: 'Standard'
                }, {
                    value: 'customize',
                    key: 'Customize'
                }],
            selectedValue: 'standard',
            onChangeFunction:'onThumbailSizeChanged'
        },
        'Thumbnail Width': {
            name: 'thumbnail.width',
            selectedValue: 100,
            type: 'number',
            hidden: true,
            default: 100,
            min:100,
            max:1000
        },
        'Thumbnail Height': {
            name: 'thumbnail.height',
            selectedValue: 75,
            type: 'number',
            hidden: true,
            default: 75,
            min:75,
            max:1000
        },
        'Embedded Attachment': {
            name: 'embeddedAttachment',
            selectedValue: false,
            type: 'checkbox',
            icon: 'fa fa-info'
        },
        'Name': {
            selectedValue: 'Display',
            hidden: true
        }
    },
    Margin: angular.copy(Props.marginObject),
    Style: {
        'font-style-group': {
            type: 'style-group',
            members: {
                'font-family': {
                    type: 'dd',
                    title: 'font.family',
                    selectedValue: 'Helvetica',
                    options: ['Arial', 'Arial Black', 'Bookman Old Style', 'Calibri', 'Century Gothic', 'Comic Sans MS', 'Courier', 'Courier New', 'Garamond', 'Georgia', 'Helvetica', 'Impact', 'Palatino Linotype', 'Sans Serif', 'Sofia Pro Regular', 'Sofia Pro Semi Bold', 'Times', 'Times New Roman', 'Trebuchet MS', 'Verdana'],
                    onChangeFunction: 'updateStyle'
                },
                'font-size': {
                    type: 'number',
                    title: 'font.size',
                    selectedValue: 14,
                    min: '1',
                    max: '99',
                    default: 14,
                    onChangeFunction: 'updateStyle'
                },
                'background-color': {
                    type: 'color-picker',
                    title: 'background.color',
                    selectedValue: '#ffffff',
                    icon: 'fa fa-paint-brush',
                    onChangeFunction: 'updateStyle'
                }
            }
        },
        'style-group': {
            type: 'style-group',
            members: {
                'bold': {
                    type: 'btn-toggle',
                    title: 'bold',
                    icon: 'fa fa-bold',
                    selectedValue: false,
                    onChangeFunction: 'updateStyle'
                }, 'italic': {
                    type: 'btn-toggle',
                    title: 'italic',
                    icon: 'fa fa-italic',
                    selectedValue: false,
                    onChangeFunction: 'updateStyle'
                }, 'underline': {
                    type: 'btn-toggle',
                    title: 'underline',
                    icon: 'fa fa-underline',
                    selectedValue: false,
                    onChangeFunction: 'updateStyle'
                },
                'alignment': {
                    type: 'radio-btn',
                    selectedValue: 'left',
                    options: [{
                        value: 'left',
                        title: 'align.left',
                        icon: 'fa fa-align-left',
                        onChangeFunction: 'updateStyle'
                    }, {
                        value: 'center',
                        title: 'align.center',
                        icon: 'fa fa-align-justify',
                        onChangeFunction: 'updateStyle'
                    }, {
                        value: 'right',
                        title: 'align.right',
                        icon: 'fa fa-align-right',
                        onChangeFunction: 'updateStyle'
                    }]
                },
                'font-color': {
                    type: 'color-picker',
                    title: 'font.color',
                    selectedValue: '#000000',
                    icon: 'fa fa-font',
                    onChangeFunction: 'updateStyle'
                }
            }
        },
        'Name': {
            selectedValue: 'style',
            hidden: true
        }
    },
    Events: {
        Name: angular.copy(Props.elementEventsObject).Name,
        load: angular.copy(Props.elementEventsObject).load,
        change: angular.copy(Props.elementEventsObject).change
    }
};

export default AttachmentProperties;


// WEBPACK FOOTER //
// ./client/app/localStorage/Controls/Attachment.ts